export default __webpack_public_path__ + "static/image13-ef4a0f1fd4d16ca7d0a4cc633a9cf1df.gif";